import { Helmet } from 'react-helmet'
import * as React from 'react'
import Layout from '../../components/Layout'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'

import GalleryContainer from '../../components/GalleryContainer'
import GalleryImage from '../../components/GalleryImage'
import { AboutContact, VideoContainer } from '..'
import { Content } from '../../components/styles'
import Button from '../../components/Button'
import { Video } from '../../components/procedures'

export default ({ data }) => (
  <Layout header="dark">
    <Helmet>
      <title>Flat / Skillion Carport | Just Patios</title>
      <meta
        name="description"
        content="Professional skillion carport builders operating in the Brisbane and Sunshine Coast. Custom designed and built skillion carports for your home. Contact us today for a completely free design & quote."
      />
    </Helmet>

    <Content style={{ paddingTop: 150 }}>
      <h1>Flat / Skillion Carport</h1>

      <h4>Queensland's most popular carport design.</h4>
      <p>
        These are by far the most popular carport designs as they are simple &
        cheap yet very effective. We can use our patio range of materials or for
        a cheaper version, zincalume sheets & a galvanised frame can be used.
        These systems are great for attaching off the side of the house or can
        be built as a free standing unit.
      </p>

      <Link to="/contact-us#form">
        <Button inverted={true}>Request Your Free Quote Today!</Button>
      </Link>
    </Content>

    <GalleryContainer>
      {data.gallery.edges
        .sort((x, y) => {
          if (
            x.node.childImageSharp === null ||
            y.node.childImageSharp === null
          ) {
            return 0
          }
          const arr = x.node.childImageSharp.fixed.src.split('/')
          const number = parseInt(arr[arr.length - 1].split('.')[0])
          const arr2 = y.node.childImageSharp.fixed.src.split('/')
          const number2 = parseInt(arr2[arr2.length - 1].split('.')[0])

          return number < number2 ? -1 : 1
        })
        .map((image, i) => {
          if (image.node.childImageSharp === null) {
            return false
          }
          const arr = image.node.childImageSharp.fixed.src.split('/')
          const name = arr[arr.length - 1].split('.')[0]
          if (name === 'cover') {
            return null
          }
          return (
            <GalleryImage modal={image.node.childImageSharp.modal}>
              <Img fixed={image.node.childImageSharp.fixed} />
            </GalleryImage>
          )
        })}
    </GalleryContainer>

    <VideoContainer style={{ marginTop: -100 }}>
      <Video
        videoId="yqTGp7gMtng"
        opts={{
          height: '576',
          width: '1024',
          playerVars: {
            color: 'white',
            rel: 0,
          },
        }}
      />
    </VideoContainer>

    <AboutContact style={{ margin: '0 auto', padding: 0 }} />
  </Layout>
)

export const query = graphql`
  query SkillionCarportQuery {
    gallery: allFile(
      filter: { relativeDirectory: { eq: "gallery/carports/skillion" } }
    ) {
      edges {
        node {
          childImageSharp {
            fixed(width: 400, height: 400, toFormat: JPG) {
              ...GatsbyImageSharpFixed
            }
            modal: fluid(maxWidth: 1200, quality: 98, toFormat: JPG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
